import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckboxOnPurple = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 2,
			width: 20,
			height: 20,
			rx: 2,
			fill: "url(#paint0_linear_22_10002)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.2603 8.20041C18.5639 8.48226 18.5815 8.95681 18.2996 9.26034L11.7996 16.2603C11.5221 16.5592 11.0566 16.5815 10.7517 16.3106L6.25174 12.3106C5.94215 12.0354 5.91426 11.5613 6.18945 11.2517C6.46464 10.9421 6.93869 10.9143 7.24828 11.1894L11.1998 14.7019L17.2004 8.23966C17.4823 7.93613 17.9568 7.91856 18.2603 8.20041Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_22_10002",
			x1: 12,
			y1: 2,
			x2: 12,
			y2: 22,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#CF73ED" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#8C0DB6"
			})]
		}) })
	]
});
export default SvgCheckboxOnPurple;
